import { createSlice } from '@reduxjs/toolkit';

import packageJson from '../../../package.json'

const currentInfo = { version: packageJson.version, name: packageJson.name, description: packageJson.description }

const states = {
  v1: {
    info: currentInfo,
    dashboard: {
      header: {
        active: true,
        fixed: true,
        offersTableView: true,
      },
      footer: {
        active: true,
        fixed: true
      },
      menu: {
        opened: true
      },
    },
    animations: {
      splashScreen: true,
    }
  },
  v2: {
    info: currentInfo,
    dashboard: {
      header: {
        active: true,
        fixed: true,
        offersTableView: true,
      },
      footer: {
        active: true,
        fixed: true
      },
      menu: {
        opened: true,
        numOfUnapprovedUsers: { display: false, number: 0 }
      },
    },
    animations: {
      splashScreen: true,
    }
  },
  v3: {
    info: currentInfo,
    dashboard: {
      header: {
        active: true,
        fixed: true,
        offersTableView: true,
      },
      footer: {
        active: true,
        fixed: true
      },
      menu: {
        opened: true,
        numOfUnapprovedUsers: { display: false, number: 0 },
        numOfOffersAccess: { display: false, number: 0 },
      },
    },
    animations: {
      splashScreen: true,
    }
  }
}

let initialState = states.v3

export const appMigration = {
  1: () => states.v1,
  2: () => states.v2,
  3: () => states.v3,
}

export const appReducer = createSlice({
  name: 'app',
  initialState,
  reducers: {
    switchMenuOpened: (state, action) => {
      state.dashboard.menu.opened = action.payload ?? !state.dashboard.menu.opened
    },
    changeMenu: (state, action) => {
      state.dashboard.menu = { ...state.dashboard.menu, ...action.payload }
    },
    changeHeader: (state, action) => {
      state.dashboard.header = { ...state.dashboard.header, ...action.payload }
    },
    changeFooter: (state, action) => {
      state.dashboard.footer = { ...state.dashboard.footer, ...action.payload }
    },
    changeDashboard: (state, action) => {
      state.dashboard = { ...state.dashboard, ...action.payload }
    },
    changeInfo: (state, action) => {
      state.info = { ...state.info, ...action.payload }
    },
    switchOpenTableView: (state, action) => {
      state.dashboard.header.offersTableView = action.payload
    }
  },
});

export const { switchMenuOpened, changeHeader, changeFooter, changeDashboard, changeInfo, changeMenu, switchOpenTableView } = appReducer.actions;

export const selectInfo = (state) => state.app.info;
export const selectDashboard = (state) => state.app.dashboard;
export const selectHeader = (state) => state.app.dashboard.header;
export const selectFooter = (state) => state.app.dashboard.footer;
export const selectMenu = (state) => state.app.dashboard.menu;
export const selectNumOfUnnaprovedUsers = (state) => state.app.dashboard.menu.numOfUnapprovedUsers;
export const selectNumOfOffersAccess = (state) => state.app.dashboard.menu.numOfOffersAccess;
export const selectTheme = (state) => state.app.dashboard.theme;
export const selectSplashScreen = (state) => state.app.animations.splashScreen
export const selectOffersTableView = (state) => state.app.dashboard.header.offersTableView;
export const selectMenuOpened = (state) => state.app.dashboard.menu.opened;

export default appReducer.reducer;